/* Danh mục dịch vụ trên API cho phiếu báo giá — tải một lần mỗi phiên; lỗi / rỗng thì phiếu dùng bảng giá mẫu */
import { useEffect, useState } from 'react';
import { getServices } from '../../api/Service';
import type { ApiSvc } from './logic';

let cache: ApiSvc[] | null = null;
let pending: Promise<ApiSvc[]> | null = null;

const load = () => {
  pending ??= getServices({ status: 0, take: 1000 })
    .then((r) => (r.data?.items ?? []).map((s) => ({ id: s.id, name: s.name.trim(), price: Number(s.price) || 0, qty: 1, cat: s.category?.name })))
    .catch(() => [] as ApiSvc[])
    .then((list) => { cache = list; return list; });
  return pending;
};

/** Danh mục dịch vụ đang bán (null = đang tải) */
export function useApiServices(): ApiSvc[] | null {
  const [list, setList] = useState(cache);
  useEffect(() => {
    let alive = true;
    if (!cache) load().then((x) => { if (alive) setList(x); });
    return () => { alive = false; };
  }, []);
  return list;
}
